import { render, staticRenderFns } from "./TFSortable.vue?vue&type=template&id=5dd0dad4&"
import script from "./TFSortable.vue?vue&type=script&lang=js&"
export * from "./TFSortable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/tablefever-websites/src/vue-apps/manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dd0dad4')) {
      api.createRecord('5dd0dad4', component.options)
    } else {
      api.reload('5dd0dad4', component.options)
    }
    module.hot.accept("./TFSortable.vue?vue&type=template&id=5dd0dad4&", function () {
      api.rerender('5dd0dad4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/custom-form/TFSortable.vue"
export default component.exports